/**
 * Eligible zipcodes for Moderna 1273 COVID-19 Vaccine Study
 * Generated from CSV - DO NOT EDIT MANUALLY
 * Total zipcodes: 320
 */
export const moderna1273EligibleZipCodes: readonly string[] = [
  "39426", "39457", "39463", "39466", "39470", "39501", "39502", "39503", "39505", "39506",
  "39507", "39520", "39521", "39522", "39525", "39529", "39530", "39531", "39532", "39533",
  "39534", "39535", "39540", "39552", "39553", "39555", "39556", "39558", "39560", "39561",
  "39562", "39563", "39564", "39565", "39566", "39567", "39568", "39569", "39571", "39572",
  "39573", "39574", "39576", "39577", "39581", "39595", "51501", "51502", "51503", "51510",
  "51525", "51526", "51534", "51536", "51540", "51541", "51542", "51545", "51546", "51548",
  "51549", "51550", "51551", "51553", "51554", "51555", "51556", "51557", "51559", "51560",
  "51561", "51563", "51564", "51565", "51570", "51571", "51575", "51576", "51579", "51653",
  "51654", "68002", "68003", "68005", "68007", "68008", "68010", "68015", "68016", "68017",
  "68018", "68019", "68022", "68023", "68025", "68026", "68028", "68029", "68031", "68033",
  "68034", "68037", "68040", "68041", "68042", "68044", "68046", "68048", "68050", "68056",
  "68058", "68059", "68061", "68063", "68064", "68066", "68068", "68069", "68070", "68072",
  "68073", "68101", "68102", "68103", "68104", "68105", "68106", "68107", "68108", "68109",
  "68110", "68111", "68112", "68113", "68114", "68116", "68117", "68118", "68119", "68122",
  "68123", "68124", "68127", "68128", "68130", "68131", "68132", "68133", "68134", "68135",
  "68136", "68137", "68138", "68139", "68142", "68144", "68145", "68147", "68152", "68154",
  "68157", "68164", "68172", "68175", "68176", "68178", "68179", "68180", "68182", "68183",
  "68197", "68198", "68304", "68307", "68336", "68347", "68349", "68366", "68403", "68407",
  "68409", "68413", "68417", "68455", "68462", "68463", "68514", "68517", "68527", "68621",
  "68648", "68649", "70051", "70052", "70071", "70076", "70084", "70086", "70090", "70339",
  "70341", "70346", "70390", "70391", "70393", "70401", "70402", "70403", "70404", "70441",
  "70443", "70449", "70451", "70452", "70453", "70461", "70462", "70466", "70704", "70706",
  "70707", "70710", "70711", "70714", "70718", "70719", "70721", "70722", "70723", "70725",
  "70726", "70727", "70728", "70729", "70730", "70732", "70733", "70734", "70736", "70737",
  "70738", "70739", "70740", "70743", "70744", "70748", "70749", "70752", "70754", "70755",
  "70756", "70757", "70759", "70760", "70761", "70762", "70763", "70764", "70765", "70767",
  "70769", "70770", "70772", "70773", "70774", "70775", "70776", "70777", "70778", "70780",
  "70783", "70784", "70785", "70786", "70788", "70789", "70791", "70792", "70801", "70802",
  "70803", "70804", "70805", "70806", "70807", "70808", "70809", "70810", "70811", "70812",
  "70813", "70814", "70815", "70816", "70817", "70818", "70819", "70820", "70821", "70822",
  "70823", "70825", "70826", "70827", "70831", "70833", "70835", "70836", "70837", "70873",
  "70874", "70879", "70884", "70891", "70892", "70893", "70894", "70895", "70896", "70898",
] as const;
